import React from "react";
import { useSelector } from "react-redux";
import { Switch } from "react-router-dom";
// helper
import { OnboardingRoute } from "helper/route";
// layout
import SentimentTrackerOnboardingLayoutContainer from "containers/SentimentTracker/sentimentTrackerOnboardingLayout/";

// pages
import SentimentTrackerCkyc from "pages/SentimentTracker/SentimentTrackerOnboarding/SentimentTrackerCkyc";
import SentimentTrackerPayment from "pages/SentimentTracker/SentimentTrackerOnboarding/SentimentTrackerPayment";
import SentimentTrackerOnboardingOverview from "pages/SentimentTracker/SentimentTrackerOnboardingOverview";

const SentimentTrackerOnboardingNavigator = (props) => {
  const { match } = props;
  const isAuthenticated = useSelector(
    (state) => state.customer.isAuthenticated
  );
  const isSentimentTrackerOnboardingCompleted = useSelector(
      (state) => state.sentimentTracker.sentimentTrackerOnboarding.isOnboardingCompleted
  );

  return (
    // new code to redirect if any onboarding completed  /customer/dashboard
    // old code to redirect if any onboarding completed  /sentiment-tracker/dashboard
    <Switch>
      <SentimentTrackerOnboardingLayoutContainer {...props}>
        <Switch>
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isSentimentTrackerOnboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/overview`}
            component={SentimentTrackerOnboardingOverview}
          />
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isSentimentTrackerOnboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/payment`}
            component={SentimentTrackerPayment}
          />
          <OnboardingRoute
            exact
            isAuthenticated={isAuthenticated}
            isOnboardingCompleted={isSentimentTrackerOnboardingCompleted}
            redirectOnboardingIncomplete={`/customer/dashboard`}
            path={`${match.path}/ckyc`}
            component={SentimentTrackerCkyc}
          />
        </Switch>
      </SentimentTrackerOnboardingLayoutContainer>
    </Switch>
  );
};

export default SentimentTrackerOnboardingNavigator;
